import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Check, Crown } from 'lucide-react';
import { mockData } from '../mock';
import Popup from './Popup';

const PricingSection = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <section className="py-20 bg-background relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] bg-[size:60px_60px]" />
        <div className="container mx-auto px-4 relative">
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="bg-secondary text-white px-4 py-2 rounded-full text-sm font-semibold">
                Pricing Plans
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">Choose Your Plan</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Transparent pricing with no hidden fees. Select the package that best fits your needs.
            </p>
          </div>

          {/* Responsive Grid Layout - Vertical Stack on Mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
            {mockData.pricingPlans.map((plan) => (
              <Card
                key={plan.id}
                className={`relative flex flex-col h-full transition-all hover:shadow-2xl hover:-translate-y-2 ${ 
                  plan.recommended 
                    ? 'border-secondary border-2 shadow-xl bg-gradient-to-br from-primary/5 to-white' 
                    : 'border-gray-200 hover:border-accent'
                }`}
              >
                {plan.recommended && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
                    <div className="bg-secondary text-white px-4 py-1.5 rounded-full text-sm font-semibold flex items-center shadow-lg">
                      <Crown className="w-4 h-4 mr-1" />
                      Recommended
                    </div>
                  </div>
                )}
                
                <CardHeader className="text-center pb-4">
                  <CardTitle className="text-2xl font-bold text-primary">{plan.name}</CardTitle>
                  <div className="mt-4">
                    <div className="text-4xl font-bold text-secondary">{plan.price}</div>
                    <div className="text-sm text-gray-600 mt-1">{plan.filingFee}</div>
                  </div>
                </CardHeader>
                
                <CardContent className="flex-grow flex flex-col">
                  <div className="flex-grow overflow-y-auto max-h-80 mb-4">
                    <ul className="space-y-3">
                      {plan.features.map((feature, index) => (
                        <li key={index} className="flex items-start">
                          <Check className="w-5 h-5 text-secondary mr-2 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-700 text-sm">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="text-xs text-gray-500 mb-4 italic">{plan.note}</div>
                  
                  <Button
                    onClick={() => setIsPopupOpen(true)}
                    className={`w-full font-semibold transition-all ${
                      plan.recommended
                        ? 'bg-secondary hover:bg-secondary/90 text-white shadow-lg hover:shadow-xl'
                        : 'bg-gray-100 hover:bg-secondary hover:text-white text-gray-900'
                    }`}
                  >
                    Select Plan
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
      
      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
};

export default PricingSection;
